import React, { useRef, useEffect } from "react";

import { Grid, Button, DialogContent } from "@material-ui/core";
import { DckActionCreators, procSuccess, procUpdating } from "dck-redux";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import { generalFormFor, useDispatchActions } from "srx-shared";
import { ActionsSpinner, ModalDialog } from "srx-shared/mui";

import { StorageSection } from "@items/types";

import { SectionConfigItem } from "./SectionConfigItem";

const SectionConfigForm = generalFormFor(SectionConfigItem);

const actions = {
  updateStorageSection: (id, data) =>
    DckActionCreators.itemSave(StorageSection, id, data)
};

export function SectionConfigDialog(props) {
  const {
    open,
    onClose,
    number,
    noWeight,
    address,
    shelfSerial,
    shelfSerialNumbers
  } = props;

  const { updateStorageSection } = useDispatchActions(actions);

  const updating = useSelector(state => procUpdating(state, StorageSection));
  const updateSuccess = useSelector(state =>
    procSuccess(state, StorageSection, "update")
  );

  const prevUpdateSuccess = useRef();
  useEffect(() => {
    if (!prevUpdateSuccess.current) {
      prevUpdateSuccess.current = updateSuccess;
    } else {
      onClose && onClose();
      prevUpdateSuccess.current = false;
    }
    return () => (prevUpdateSuccess.current = false);
  });

  const handleSubmit = data => {
    const { storageId, distributorId, id, number } = props;

    const noWeight = data.noWeight === "true";
    const sectionConfig = {
      id,
      number,
      noWeight,
      smartShelfHardware: {
        id: data.shelfSerial && !noWeight ? data.shelfSerial : null
      },
      distributorId
    };

    updateStorageSection && updateStorageSection(storageId, sectionConfig);
  };

  const renderActions = (form, formikProps) => {
    const { dirty } = formikProps;
    const disabled = !dirty || updating;
    return (
      <Grid container justify="flex-end" style={{ padding: "32px 0 0 0" }}>
        <ActionsSpinner processing={updating} />
        <Button
          variant="contained"
          color="default"
          onClick={props.onClose}
          style={{ marginRight: 16 }}
        >
          Cancel
        </Button>
        <Button
          type="submit"
          variant="contained"
          color="secondary"
          disabled={disabled}
        >
          Save
        </Button>
      </Grid>
    );
  };

  const initialData = {
    noWeight: noWeight ? "true" : "false",
    address,
    shelfSerial: shelfSerial || null,
    shelfSerialNumbers
  };

  return (
    <ModalDialog
      open={open}
      onClose={onClose}
      title={`Configure Section #${number}`}
      size="xs"
    >
      <DialogContent>
        <SectionConfigForm
          initialData={initialData}
          renderActions={renderActions}
          onSubmit={handleSubmit}
        />
      </DialogContent>
    </ModalDialog>
  );
}

SectionConfigDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  id: PropTypes.number,
  number: PropTypes.number,
  storageId: PropTypes.number,
  distributorId: PropTypes.number,
  noWeight: PropTypes.bool,
  address: PropTypes.string,
  shelfSerial: PropTypes.number,
  shelfSerialNumbers: PropTypes.array
};
